export const setUser = (data) => dispatch => {
    dispatch({ type: "SAVING_USER_CREDENTIALS", payload: data });
};
export const removeUser = (data) => dispatch => {
    dispatch({ type: "REMOVING_USER_CREDENTIALS" });
};